/**
 * A function to create a log object for the 'smsVerificationTooManyMessages' event (evid: 1084)
 *
 * Event description: The user has passed the limit for number of SMS messages sent
 *
 * @param {smsVerificationTooManyMessagesParams} params - The parameters for this event
 * @return {LogObject<smsVerificationTooManyMessagesParams>} LogObject<smsVerificationTooManyMessagesParams>
 */
export function smsVerificationTooManyMessages(params) {
    return { evid: 1084, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotPhoneNumberClose' event (evid: 1070)
 *
 * Event description: The user closes the phone number entry popup
 *
 * @param {chatbotPhoneNumberCloseParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} method - did the user close out of the popup or enter their phone number
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotPhoneNumberCloseParams>} LogObject<chatbotPhoneNumberCloseParams>
 */
export function chatbotPhoneNumberClose(params) {
    return { evid: 1070, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotDomainSelectorOpen' event (evid: 1063)
 *
 * Event description: The user is shown the domain selector
 *
 * @param {chatbotDomainSelectorOpenParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {number} num_domains_listed - number of domains shown to the user
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotDomainSelectorOpenParams>} LogObject<chatbotDomainSelectorOpenParams>
 */
export function chatbotDomainSelectorOpen(params) {
    return { evid: 1063, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotSiteSelectorClose' event (evid: 1060)
 *
 * Event description: The user closes the site selector
 *
 * @param {chatbotSiteSelectorCloseParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} method - did the user close the popup, select a site, or click "I don't see my site"
 * @property {GUID} msid - msid of selected site (null if no site selected)
 * @property {number} num_sites_listed - number of sites shown to the user
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotSiteSelectorCloseParams>} LogObject<chatbotSiteSelectorCloseParams>
 */
export function chatbotSiteSelectorClose(params) {
    return { evid: 1060, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotDialogueflowIntentTesting' event (evid: 1091)
 *
 * Event description: Only use for testing, do not use in production
 *
 * @param {chatbotDialogueflowIntentTestingParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} confidence - Confidence Level returned by Dialogflow
 * @property {string} intent_id - ID of the matched intent from Dialogflow
 * @property {string} intent_name - the matched intent from Dialogflow
 * @property {string} list_name - List of the strings being tested
 * @property {string} message - User message with PII removed
 * @property {string} nlp_version - Version of the NLP used
 * @property {string} true_intent - The real intent of the message (determined manually)
 * @property {string} true_intent_id - ID of the real intent of the message (determined manually)
 * @return {LogObject<chatbotDialogueflowIntentTestingParams>} LogObject<chatbotDialogueflowIntentTestingParams>
 */
export function chatbotDialogueflowIntentTesting(params) {
    return { evid: 1091, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotSiteSelectorOpen' event (evid: 1059)
 *
 * Event description: The user is shown the site selector
 *
 * @param {chatbotSiteSelectorOpenParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {number} num_sites_listed - number of sites shown to the user
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotSiteSelectorOpenParams>} LogObject<chatbotSiteSelectorOpenParams>
 */
export function chatbotSiteSelectorOpen(params) {
    return { evid: 1059, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotUserMessageClient' event (evid: 1107)
 *
 * Event description: The user clicks on something that does not trigger a backend BI event
 *
 * @param {chatbotUserMessageClientParams} params - The parameters for this event
 * @property {string} action_type - action the user is taking (click link, CTA, send message, etc.))
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} button_id - id of the button clicked
 * @property {string} button_name - name of the button clicked
 * @property {string} chat_type - live or chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} extraInfo - any extra relevant info
 * @property {string} input_type - did the user click on a button, enter freeform text, etc.
 * @property {string} intent_id - ID of the user_intent
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @property {string} live_chat_group - Name of the group causing the user to go to live chat (payments, partners, etc)
 * @property {string} main_option_id - id for the category the user clicked
 * @property {string} main_option_name - category the user clicked (domains, mailboxes, etc.)
 * @property {string} message - User message with PII removed
 * @property {GUID} message_id - ID of the message
 * @property {number} position - position of the button (left-to-right, top-to-bottom)
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {boolean} soft_goal_met - Is this action the soft goal for the user's flow?
 * @property {string} soft_goal_name - Name of the goal the user is meeting
 * @property {string} ticket_id - ticket id
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotUserMessageClientParams>} LogObject<chatbotUserMessageClientParams>
 */
export function chatbotUserMessageClient(params) {
    return { evid: 1107, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotChatbotLoadFailure' event (evid: 1094)
 *
 * Event description: User fails to loads the chatbot
 *
 * @param {chatbotChatbotLoadFailureParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} issue - Reason the chatbot failed
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} payload - chatbot's payload
 * @property {Url} referral_url - url that directed the user to the chatbot
 * @property {string} session_id - Widget session ID
 * @property {number} ts - total load time of the page, in ms
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @return {LogObject<chatbotChatbotLoadFailureParams>} LogObject<chatbotChatbotLoadFailureParams>
 */
export function chatbotChatbotLoadFailure(params) {
    return { evid: 1094, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotArticleLoad' event (evid: 1112)
 *
 * Event description: The user loads an article in the chatbot.
 *
 * @param {chatbotArticleLoadParams} params - The parameters for this event
 * @property {GUID} article_id - ID of articles shown to the user
 * @property {string} article_name - the title of the presented article
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - id of the conversation
 * @property {string} extraInfo - anything not covered in the other fields
 * @property {string} input_type - did the user click on a button, enter freeform text, etc.
 * @property {string} main_option_name - main category of the chatbot
 * @property {string} message - User message with PII removed
 * @property {string} node_id - ID of the chatbot node
 * @property {string} node_name - name of the chatbot node
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_intent - Issue the user is trying to solve
 * @return {LogObject<chatbotArticleLoadParams>} LogObject<chatbotArticleLoadParams>
 */
export function chatbotArticleLoad(params) {
    return { evid: 1112, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotCloseTicket' event (evid: 1105)
 *
 * Event description: The user's ticket is automatically closed when they switch to a callback or chat
 *
 * @param {chatbotCloseTicketParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} main_option_name - Category of the user's ticket
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotCloseTicketParams>} LogObject<chatbotCloseTicketParams>
 */
export function chatbotCloseTicket(params) {
    return { evid: 1105, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'newEvent' event (evid: 1166)
 *
 * Event description: adding 2 columns for a new test
 *
 * @param {newEventParams} params - The parameters for this event
 * @return {LogObject<newEventParams>} LogObject<newEventParams>
 */
export function newEvent(params) {
    return { evid: 1166, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationCodeSubmissionFormOpened' event (evid: 1081)
 *
 * Event description: The verification message is received by the phone number entered by the user.
 *
 * @param {smsVerificationCodeSubmissionFormOpenedParams} params - The parameters for this event
 * @return {LogObject<smsVerificationCodeSubmissionFormOpenedParams>} LogObject<smsVerificationCodeSubmissionFormOpenedParams>
 */
export function smsVerificationCodeSubmissionFormOpened(params) {
    return { evid: 1081, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotPhoneNumberOpen' event (evid: 1069)
 *
 * Event description: The user is shown the phone number entry popup
 *
 * @param {chatbotPhoneNumberOpenParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotPhoneNumberOpenParams>} LogObject<chatbotPhoneNumberOpenParams>
 */
export function chatbotPhoneNumberOpen(params) {
    return { evid: 1069, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotBackToCategories' event (evid: 1055)
 *
 * Event description: The user clicks the back to categories button to return to the contact page
 *
 * @param {chatbotBackToCategoriesParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} node_id - ID of the chatbot node
 * @property {string} node_name - name of the current chatbot node
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotBackToCategoriesParams>} LogObject<chatbotBackToCategoriesParams>
 */
export function chatbotBackToCategories(params) {
    return { evid: 1055, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'liveChatAgentEntersLeavesChat' event (evid: 1102)
 *
 * Event description: Sent when the agent enters or leaves the chat
 *
 * @param {liveChatAgentEntersLeavesChatParams} params - The parameters for this event
 * @property {string} action - enter or exit
 * @property {GUID} agent_id - id of the Wix Agent
 * @property {string} conversation_id - id of the chatbot conversation
 * @property {string} extraInfo - any extra relevant info
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<liveChatAgentEntersLeavesChatParams>} LogObject<liveChatAgentEntersLeavesChatParams>
 */
export function liveChatAgentEntersLeavesChat(params) {
    return { evid: 1102, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotIntentMatched' event (evid: 1057)
 *
 * Event description: Sent when the chatbot tries to understand a user's free text message.
 *
 * @param {chatbotIntentMatchedParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} conversation_id - ID of the conversation
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} node_id - ID of the chatbot node
 * @property {string} nodeId - name of the current chatbot node
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} session_id - Widget session ID
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotIntentMatchedParams>} LogObject<chatbotIntentMatchedParams>
 */
export function chatbotIntentMatched(params) {
    return { evid: 1057, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotDomainSelectorClose' event (evid: 1066)
 *
 * Event description: The user closes the domain selector
 *
 * @param {chatbotDomainSelectorCloseParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} domain - domain selected (null if no domain selected)
 * @property {string} method - did the user close the popup, select a domain, or click "I don't see my site"
 * @property {number} num_domains_listed - number of domains shown to the user
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotDomainSelectorCloseParams>} LogObject<chatbotDomainSelectorCloseParams>
 */
export function chatbotDomainSelectorClose(params) {
    return { evid: 1066, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationExitOutOfCodeSubmissionForm' event (evid: 1087)
 *
 * Event description: The user exits out of the form for code submission
 *
 * @param {smsVerificationExitOutOfCodeSubmissionFormParams} params - The parameters for this event
 * @return {LogObject<smsVerificationExitOutOfCodeSubmissionFormParams>} LogObject<smsVerificationExitOutOfCodeSubmissionFormParams>
 */
export function smsVerificationExitOutOfCodeSubmissionForm(params) {
    return { evid: 1087, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'dummyName' event (evid: 1050)
 *
 * @param {dummyNameParams} params - The parameters for this event
 * @return {LogObject<dummyNameParams>} LogObject<dummyNameParams>
 */
export function dummyName(params) {
    return { evid: 1050, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotArticleLoadFailure' event (evid: 1096)
 *
 * @param {chatbotArticleLoadFailureParams} params - The parameters for this event
 * @property {string} articles_shown - IDs of articles that were supposed to be shown to the user (comma separated)
 * @property {GUID} bot_id
 * @property {string} conversation_id - id of the conversation
 * @property {string} extraInfo
 * @property {string} input_type - did the user click on a button, enter freeform text, etc.
 * @property {string} issue - Reason the article failed to load
 * @property {string} main_option_name
 * @property {string} message - User message with PII removed
 * @property {string} node_id - ID of the chatbot node
 * @property {string} node_name - name of the chatbot node
 * @property {string} prediction_id
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} previous_node_name
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_intent
 * @return {LogObject<chatbotArticleLoadFailureParams>} LogObject<chatbotArticleLoadFailureParams>
 */
export function chatbotArticleLoadFailure(params) {
    return { evid: 1096, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotClickAnchor' event (evid: 1118)
 *
 * Event description: The user clicks on the chatbot anchor to open the chatbot
 *
 * @param {chatbotClickAnchorParams} params - The parameters for this event
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} lang - Answers language
 * @property {GUID} msid - msid when relevant
 * @property {number} notificationCount - Number of chat notifications the user had
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} orig_platform - Location of chat start
 * @property {string} referral_info - Where the user is coming from
 * @property {GUID} visitor_id - visitor_id of the user since conversation_id is not available
 * @return {LogObject<chatbotClickAnchorParams>} LogObject<chatbotClickAnchorParams>
 */
export function chatbotClickAnchor(params) {
    return { evid: 1118, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationResendMyCode' event (evid: 1085)
 *
 * Event description: The user asks for another SMS messages to be sent
 *
 * @param {smsVerificationResendMyCodeParams} params - The parameters for this event
 * @return {LogObject<smsVerificationResendMyCodeParams>} LogObject<smsVerificationResendMyCodeParams>
 */
export function smsVerificationResendMyCode(params) {
    return { evid: 1085, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotSupportRequestSubmitted' event (evid: 1092)
 *
 * Event description: The user submits a support request through the chatbot
 *
 * @param {chatbotSupportRequestSubmittedParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} main_option_id - id for the category the user clicked
 * @property {string} main_option_name - category the user clicked (domains, mailboxes, etc.)
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} request_type - Did the user request a ticket or callback
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotSupportRequestSubmittedParams>} LogObject<chatbotSupportRequestSubmittedParams>
 */
export function chatbotSupportRequestSubmitted(params) {
    return { evid: 1092, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotViewSolution' event (evid: 1090)
 *
 * Event description: The user views a solution on the Chatbot
 *
 * @param {chatbotViewSolutionParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} node_id - node ID of the chatbot message
 * @property {string} node_name - name of the chatbot node
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} solution_id - id of the solution the user viewed
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotViewSolutionParams>} LogObject<chatbotViewSolutionParams>
 */
export function chatbotViewSolution(params) {
    return { evid: 1090, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotSeeMoreInfo' event (evid: 1068)
 *
 * Event description: The user clicks the see more info button on a chatbot message
 *
 * @param {chatbotSeeMoreInfoParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} node_id - ID of the chatbot node
 * @property {string} node_name - name of the chatbot node
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotSeeMoreInfoParams>} LogObject<chatbotSeeMoreInfoParams>
 */
export function chatbotSeeMoreInfo(params) {
    return { evid: 1068, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotChangeMessage' event (evid: 1067)
 *
 * Event description: The user clicks the "Change" button on a previous message
 *
 * @param {chatbotChangeMessageParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {number} last_node - the last chatbot node when the user changes the message
 * @property {string} last_node_name - name of the last chatbot node when the user changes the message
 * @property {number} messages_ago - number of messages the user sent after the message they want to change
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} previous_node_id - node ID of the chatbot message previous to the changed message
 * @property {string} previous_node_name - name of the chatbot node previous to the changed message
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotChangeMessageParams>} LogObject<chatbotChangeMessageParams>
 */
export function chatbotChangeMessage(params) {
    return { evid: 1067, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotFallback' event (evid: 1058)
 *
 * Event description: Sent when the chatbot cannot solve the user’s issue
 *
 * @param {chatbotFallbackParams} params - The parameters for this event
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} node_id - ID of the chatbot node
 * @property {number} previous_node - node ID of the previous chatbot message
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotFallbackParams>} LogObject<chatbotFallbackParams>
 */
export function chatbotFallback(params) {
    return { evid: 1058, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationCallMeWithTheCode' event (evid: 1086)
 *
 * Event description: The user asks for a call for the code
 *
 * @param {smsVerificationCallMeWithTheCodeParams} params - The parameters for this event
 * @return {LogObject<smsVerificationCallMeWithTheCodeParams>} LogObject<smsVerificationCallMeWithTheCodeParams>
 */
export function smsVerificationCallMeWithTheCode(params) {
    return { evid: 1086, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotAlert' event (evid: 1098)
 *
 * Event description: The chatbot shows an alert to the user.
 *
 * @param {chatbotAlertParams} params - The parameters for this event
 * @property {string} alertName - Alert shown to the user
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} input_type - did the user click on a button, rotate, etc.
 * @property {string} main_option_id - id for the category the user clicked
 * @property {string} main_option_name - category the user clicked (domains, mailboxes, etc.)
 * @property {string} orientation - Orientation when the event is triggered
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @return {LogObject<chatbotAlertParams>} LogObject<chatbotAlertParams>
 */
export function chatbotAlert(params) {
    return { evid: 1098, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotLoadChatbot' event (evid: 1051)
 *
 * Event description: User successfully loads the chatbot
 *
 * @param {chatbotLoadChatbotParams} params - The parameters for this event
 * @property {string} node_name - Name of the chatbot node
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - DEPRECATED- DO NOT USE!
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbotFloating, helpWidgetFloating, chatbotContactPage, helpWidgetContactPage
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {number} ts - total load time of the page, in ms
 * @property {string} referral_info - DEPRECATED- DO NOT USE!
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} real_estate_id - real_estate_id
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} group_name - Reason the user is seeing the chatbot. (Contact Page, Partners, Stores...)
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} offer_id - offer_id
 * @property {string} suggestion_id - suggestion_id
 * @property {string} lang - Language of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {string} parent_url - the url where the user sees the widget
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotLoadChatbotParams>} LogObject<chatbotLoadChatbotParams>
 */
export function chatbotLoadChatbot(params) {
    return { evid: 1051, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotUserMessage' event (evid: 1052)
 *
 * Event description: The user clicks on any part of the chatbot
 *
 * @param {chatbotUserMessageParams} params - The parameters for this event
 * @property {string} ticket_id - ticket id
 * @property {string} node_name - node_name
 * @property {string} selected_account - The account selected by the user in the Account-Selector
 * @property {string} main_option_id - id for the category the user clicked
 * @property {string} chosen_site - The msid of the site chosen by the user in the Site-Selector
 * @property {string} button_type - the type of the button_id chosen by the user
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - DEPRECATED- DO NOT USE!
 * @property {string} survey_interaction_id - id of interaction (related for surveys only)
 * @property {string} context_platform - context_platform
 * @property {string} button_id_list - list of all button ids shown to the user in order, separated by commas
 * @property {string} soft_goal_name - Name of the goal the user is meeting
 * @property {string} node_type_id - ID of node_type
 * @property {string} button_type_id - the button ID type of the chosen button_id
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_type - Classification of node (solution, chatbot feedback, etc)
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} input_type - did the user click on a button, enter freeform text, etc.
 * @property {string} button_name - name of the button clicked
 * @property {string} intent_id - ID of the user_intent
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} button_name_list - list of all button names shown to the user in order, separated by |
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {GUID} message_id - ID of the message
 * @property {string} button_id - id of the button clicked
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - category the user clicked (domains, mailboxes, etc.)
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} request_id - ID of the support request (ticket, call, chat) from earlier in the conversation
 * @property {number} position - position of the button (left-to-right, top-to-bottom)
 * @property {string} message - User message with PII removed
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @property {string} chat_type - live or chatbot
 * @property {string} conversation_id - ID of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} group - Reason the user is seeing the chatbot. (Contact Page, Partners, Stores...)
 * @property {string} action_type - action the user is taking (click link, CTA, send message, etc.))
 * @property {number} sites_count - The number of sites the user has
 * @property {string} chatbot_state - chatbot_state
 * @property {string} live_chat_group - Name of the group causing the user to go to live chat (payments, partners, etc)
 * @property {string} parent_url - the url where the user sees the widget
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {boolean} soft_goal_met - Is this action the soft goal for the user's flow?
 * @return {LogObject<chatbotUserMessageParams>} LogObject<chatbotUserMessageParams>
 */
export function chatbotUserMessage(params) {
    return { evid: 1052, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotChatbotMessage' event (evid: 1053)
 *
 * Event description: Sent every time the chatbot sends a batch of messages to the user
 *
 * @param {chatbotChatbotMessageParams} params - The parameters for this event
 * @property {number} num_of_messages - number_of_messages- number of separate messages in this batch
 * @property {string} ticket_id - ticket id
 * @property {string} solution_ids - The article ID if was suggested by the chatbot; The article IDs if a selector was involved in the process
 * @property {string} node_name - name of the chatbot node
 * @property {string} selected_account - The account selected by the user in the Account-Selector
 * @property {string} main_option_id - ID of the Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - DEPRECATED- DO NOT USE!
 * @property {string} survey_interaction_id - id of interaction (related for surveys only)
 * @property {string} context_platform - context_platform
 * @property {string} button_id_list - IDs of all the button options shown to the user
 * @property {string} node_type_id - ID of node_type
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_type - Classification of node (solution, chatbot feedback, etc)
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {GUID} reported_abuse_msid - reported_abuse_msid
 * @property {string} kb_widget_state - Number of threads opened
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} input_type - did the user click on a button, enter freeform text, etc.
 * @property {string} intent_id - id of the user_intent
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} message_text - text of the message sent by the chatbot
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} next_suggestion_ids - next_suggestion_ids
 * @property {string} user_agent - user_agent
 * @property {string} button_name_list - button_name_list
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {GUID} message_id - ID of the message
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} reported_abuse_premium_state - reported_abuse_premium_state
 * @property {string} group_name - Reason the user is seeing the chatbot. (Contact Page, Partners, Stores...)
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} user_response_type - does the node allow for free text, bubbles, popup, or some combination?
 * @property {string} lang - Displayed language
 * @property {string} conversation_id - id of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {number} sites_count - The number of sites the user has
 * @property {string} chatbot_state - chatbot_state
 * @property {string} parent_url - the url where the user sees the widget
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotChatbotMessageParams>} LogObject<chatbotChatbotMessageParams>
 */
export function chatbotChatbotMessage(params) {
    return { evid: 1053, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotStartOver' event (evid: 1054)
 *
 * Event description: The user clicks the Start Over button to restart the chat
 *
 * @param {chatbotStartOverParams} params - The parameters for this event
 * @property {string} node_name - name of the current chatbot node
 * @property {string} main_option_id - ID of the Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - widget, full screen, iframe, mobile
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - Number of threads opened
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @property {string} conversation_id - ID of the conversation
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotStartOverParams>} LogObject<chatbotStartOverParams>
 */
export function chatbotStartOver(params) {
    return { evid: 1054, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotContactSupport' event (evid: 1056)
 *
 * Event description: The user responds “Yes” to the question “Do you still need to talk to support?”
 *
 * @param {chatbotContactSupportParams} params - The parameters for this event
 * @property {string} node_name - name of the current chatbot node
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} node_id - ID of the chatbot node
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {GUID} bot_id - ID of the chatbot
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} conversation_id - ID of the conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @return {LogObject<chatbotContactSupportParams>} LogObject<chatbotContactSupportParams>
 */
export function chatbotContactSupport(params) {
    return { evid: 1056, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationMessageSent' event (evid: 1080)
 *
 * Event description: The verification message is sent to the phone number entered by the user.
 *
 * @param {smsVerificationMessageSentParams} params - The parameters for this event
 * @property {string} ticket_id - answers' ticket id of the created call
 * @property {string} session_id - Widget session ID
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} phone_number_error - Null if there is no error
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} lang - Language of the chatbot
 * @property {string} conversation_id - conversation_id
 * @return {LogObject<smsVerificationMessageSentParams>} LogObject<smsVerificationMessageSentParams>
 */
export function smsVerificationMessageSent(params) {
    return { evid: 1080, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationCodeSubmitted' event (evid: 1082)
 *
 * Event description: The user successfully submits the code sent to their phone
 *
 * @param {smsVerificationCodeSubmittedParams} params - The parameters for this event
 * @property {string} ticket_id - answers' ticket id of the created call
 * @property {string} session_id - Widget session ID
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} lang - Language of the chatbot
 * @property {string} conversation_id - ID of the conversation
 * @return {LogObject<smsVerificationCodeSubmittedParams>} LogObject<smsVerificationCodeSubmittedParams>
 */
export function smsVerificationCodeSubmitted(params) {
    return { evid: 1082, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationCodeSubmissionError' event (evid: 1083)
 *
 * Event description: The user submits an incorrect code
 *
 * @param {smsVerificationCodeSubmissionErrorParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} lang - Language of the chatbot
 * @property {string} conversation_id - conversation_id
 * @return {LogObject<smsVerificationCodeSubmissionErrorParams>} LogObject<smsVerificationCodeSubmissionErrorParams>
 */
export function smsVerificationCodeSubmissionError(params) {
    return { evid: 1083, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotClickLink' event (evid: 1088)
 *
 * Event description: The user clicks on a link from the chatbot
 *
 * @param {chatbotClickLinkParams} params - The parameters for this event
 * @property {string} node_id - previous_node_id
 * @property {string} node_name - name of the chatbot node
 * @property {string} main_option_id - main_option_id
 * @property {string} linkUrl - url of the link the user clicked
 * @property {string} button_type - Did the user click a link or CTA
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - lang
 * @property {string} conversation_id - ID of the conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotClickLinkParams>} LogObject<chatbotClickLinkParams>
 */
export function chatbotClickLink(params) {
    return { evid: 1088, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotDialogueflowIntentMatch' event (evid: 1089)
 *
 * Event description: Dialogueflow is given input by the user and returns a matching intent.
 *
 * @param {chatbotDialogueflowIntentMatchParams} params - The parameters for this event
 * @property {string} node_name - name of the chatbot node
 * @property {string} main_option_id - main_option_id
 * @property {string} entity_string - Part of the user's message that matched the DF entities separated by commas
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} intent_name_multiple - cases of several results of entity
 * @property {string} node_id - node ID of the chatbot message
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {boolean} low_sentiment - Flags if the user has a low sentiment that will be flagged by our system
 * @property {string} intent_prediction_id - intent_prediction_id
 * @property {string} referral_info - referral_info
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} confidence_multiple - confidence rate for multiple intents
 * @property {string} agent_name - agent_name
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} confidence - Confidence Level returned by Dialogflow
 * @property {string} agent - Wix_Context or MegaBot
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} version - Version of Dialogflow
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} entity_name - All Dialogflow entities matched by the user's message separated by commas
 * @property {string} referral - referral
 * @property {string} entity_prediction_id - entity_prediction_id
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} intent_name - the matched intent from Dialogflow
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - previous intent of the user before Dialogflow
 * @property {string} df_context_name - Context passed from one DF agent to another
 * @property {string} product_mapping - product mapping for DS team
 * @property {string} message - User message with PII removed
 * @property {string} sentiment_magnitude - magnitude returned by Dialogflow sentiment analysis
 * @property {string} lang - Answers language
 * @property {string} conversation_id - ID of the conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {string} model_environment - model_environment
 * @property {string} url_mapping - url mapping for DS team
 * @property {string} sentiment_score - score returned by Dialogflow sentiment analysis
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotDialogueflowIntentMatchParams>} LogObject<chatbotDialogueflowIntentMatchParams>
 */
export function chatbotDialogueflowIntentMatch(params) {
    return { evid: 1089, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotArticlePrediction' event (evid: 1093)
 *
 * Event description: Sent when a user is shown an article from the data science prediction model
 *
 * @param {chatbotArticlePredictionParams} params - The parameters for this event
 * @property {string} node_name - name of the chatbot node
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} input_type - did the user click on a button, enter freeform text, etc.
 * @property {string} referral_info - referral_info
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} articles_shown - IDs of articles shown to the user (comma separated)
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} prediction_id - id of the article prediction
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} message - User message with PII removed
 * @property {string} model_name - model_name
 * @property {string} lang - lang
 * @property {string} conversation_id - id of the conversation
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotArticlePredictionParams>} LogObject<chatbotArticlePredictionParams>
 */
export function chatbotArticlePrediction(params) {
    return { evid: 1093, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotFunctionFailure' event (evid: 1095)
 *
 * Event description: A chatbot function fails
 *
 * @param {chatbotFunctionFailureParams} params - The parameters for this event
 * @property {string} node_name - name of the chatbot node
 * @property {string} function_name - Function that failed
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} issue - Reason the function failed
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} suggestion_id - suggestion_id
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @property {string} conversation_id - id of the conversation
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotFunctionFailureParams>} LogObject<chatbotFunctionFailureParams>
 */
export function chatbotFunctionFailure(params) {
    return { evid: 1095, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotToggleSwitch' event (evid: 1097)
 *
 * Event description: A switch on the chatbot's setting page (https://www.wix.com/support/conversations/settings?botId=717b0e2d-a564-4ef7-b965-481b1983133b) is toggle on or off
 *
 * @param {chatbotToggleSwitchParams} params - The parameters for this event
 * @property {number} chats_per_agent - Number of live chats per agent
 * @property {boolean} toggle_state - True when the toggle is being switched on
 * @property {string} toggleName - name of the toggle being switch
 * @property {string} wait_time - maximum waiting time for live chat toggle
 * @property {string} button_text - text on the announcement banner's button
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} announcement_text - Message of the announcement banner
 * @property {string} lang - Language of toggle
 * @property {number} num_agents - Number of agents in Live Chat
 * @property {Url} button_link - link included in the announcement banner
 * @return {LogObject<chatbotToggleSwitchParams>} LogObject<chatbotToggleSwitchParams>
 */
export function chatbotToggleSwitch(params) {
    return { evid: 1097, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'triggerTrialChurnModelFromSupportRequest' event (evid: 1099)
 *
 * Event description: right after chatbot triggers the model it sends a monitor event
 *
 * @param {triggerTrialChurnModelFromSupportRequestParams} params - The parameters for this event
 * @property {string} node_name - node_name
 * @property {string} context - chatbot
 * @property {string} node_id - node_id
 * @property {GUID} bot_id - bot id
 * @property {string} subscription_id - subscription_id
 * @property {string} interaction_type_name - interaction_type_name
 * @property {string} conversation_id - conversation_id
 * @return {LogObject<triggerTrialChurnModelFromSupportRequestParams>} LogObject<triggerTrialChurnModelFromSupportRequestParams>
 */
export function triggerTrialChurnModelFromSupportRequest(params) {
    return { evid: 1099, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'liveChatAgentMessage' event (evid: 1100)
 *
 * Event description: Sent every time a Wix agent sends a message to the user
 *
 * @param {liveChatAgentMessageParams} params - The parameters for this event
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} message_text - text of the message sent by the chatbot
 * @property {string} user_agent - user_agent
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} conversation_id - id of the chatbot conversation
 * @property {GUID} agent_id - Wix agent sending the message
 * @return {LogObject<liveChatAgentMessageParams>} LogObject<liveChatAgentMessageParams>
 */
export function liveChatAgentMessage(params) {
    return { evid: 1100, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'liveChatCloseChat' event (evid: 1101)
 *
 * Event description: The user or agent closes the chat
 *
 * @param {liveChatCloseChatParams} params - The parameters for this event
 * @property {string} main_option_id - ID of the Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} close_method - agent or user
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} user_agent - user_agent
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} lang - lang
 * @property {string} conversation_id - id of the chatbot conversation
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} live_chat_group - reason the user was given the option to chat
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<liveChatCloseChatParams>} LogObject<liveChatCloseChatParams>
 */
export function liveChatCloseChat(params) {
    return { evid: 1101, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'liveChatLoadChat' event (evid: 1103)
 *
 * Event description: When the user switches to live chat
 *
 * @param {liveChatLoadChatParams} params - The parameters for this event
 * @property {string} main_option_id - ID of the Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} previous_node_id - Chatbot node before live chat
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} previous_node_name - Chatbot node before live chat
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} extraInfo - any extra relevant info
 * @property {string} conversation_id - id of the chatbot conversation
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} live_chat_group - Name of the group causing the user to go to live chat (payments, partners, etc)
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<liveChatLoadChatParams>} LogObject<liveChatLoadChatParams>
 */
export function liveChatLoadChat(params) {
    return { evid: 1103, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'liveChatChatStatus' event (evid: 1104)
 *
 * Event description: Returns whether or not live chat is available to the user
 *
 * @param {liveChatChatStatusParams} params - The parameters for this event
 * @property {string} main_option_id - ID of the Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} previous_node_id - Chatbot node before live chat
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} previous_node_name - Chatbot node before live chat
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} reason - Why Live Chat is unavailable (null if chat is available)
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} suggestion_id - suggestion_id
 * @property {string} status_text - Is Live Chat available to this users
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - Language used by the chatbot (from Answers)
 * @property {string} conversation_id - id of the chatbot conversation
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - chatbot_state
 * @property {string} live_chat_group - reason the user is seeing the live chat option
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<liveChatChatStatusParams>} LogObject<liveChatChatStatusParams>
 */
export function liveChatChatStatus(params) {
    return { evid: 1104, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotDragWidget' event (evid: 1108)
 *
 * Event description: The event is triggered whenever a user drags the widget
 *
 * @param {chatbotDragWidgetParams} params - The parameters for this event
 * @property {string} node_name - Name of the chatbot node
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} old_position - {X,Y}
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} new_position - {X,Y}
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - the referral of the widget
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} widget_state - {open, closed}
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotDragWidgetParams>} LogObject<chatbotDragWidgetParams>
 */
export function chatbotDragWidget(params) {
    return { evid: 1108, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotOpenWidget' event (evid: 1109)
 *
 * Event description: The chatbot widget is opened after being minimized
 *
 * @param {chatbotOpenWidgetParams} params - The parameters for this event
 * @property {number} context_page_numLevels - context_page_numlevels
 * @property {string} context_page_topLevelRoute - context_page_toplevelroute
 * @property {string} context_parentUrl - context_parenturl
 * @property {string} context_page_queryParams - context_page_queryparams
 * @property {string} context_parenturl - context_parenturl
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} context_iframeUrlList - context_iframeurllist
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} node_name - Name of the chatbot node
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - mapping_url
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} widget_open_origin - where the user opened the widget from (editor top bar, editor component, etc.)
 * @property {number} notificationCount - Number of chat notifications the user had
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} priority_class - The priority class of the user
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_urlChunks - context_page_urlchunks
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @return {LogObject<chatbotOpenWidgetParams>} LogObject<chatbotOpenWidgetParams>
 */
export function chatbotOpenWidget(params) {
    return { evid: 1109, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotCloseWidget' event (evid: 1110)
 *
 * Event description: The chatbot widget is closed after being opened
 *
 * @param {chatbotCloseWidgetParams} params - The parameters for this event
 * @property {string} node_name - Name of the chatbot node
 * @property {string} session_id - Widget session ID
 * @property {string} closing_trigger - The trigger for closing the widget {close_button, click_outside_widget}
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - mapping_url
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotCloseWidgetParams>} LogObject<chatbotCloseWidgetParams>
 */
export function chatbotCloseWidget(params) {
    return { evid: 1110, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotLoadWidget' event (evid: 1111)
 *
 * Event description: The chatbot widget is loaded
 *
 * @param {chatbotLoadWidgetParams} params - The parameters for this event
 * @property {string} node_name - Name of the chatbot node
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} context_parenturl - context_parenturl
 * @property {number} notificationCount - Number of chat notifications the user had
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} real_estate_id - Dealer real estate ID
 * @property {string} issue - in case of failure to send context fields, there will be a string explaining what failed
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} dealer_offer_id - Null if no dealer offer exists
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} offer_id - Dealer offer ID
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} widget_state - open or closed
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} init_params - init params widget was called with
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} triggerType - Reason the widget appeared (dealer offer, active session, etc.)
 * @return {LogObject<chatbotLoadWidgetParams>} LogObject<chatbotLoadWidgetParams>
 */
export function chatbotLoadWidget(params) {
    return { evid: 1111, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotLoadWidgetAttempt' event (evid: 1113)
 *
 * Event description: The user attempts to load the chatbot widget
 *
 * @param {chatbotLoadWidgetAttemptParams} params - The parameters for this event
 * @property {string} node_name - Name of the chatbot node
 * @property {string} session_id - Widget session ID
 * @property {string} node_id - ID of the chatbot node
 * @property {number} notificationCount - Number of chat notifications the user had
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {GUID} visitor_id - visitor ID used for load widget events when uuid is unavailable
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} widget_state - open or closed
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} init_params - init params widget was called with
 * @return {LogObject<chatbotLoadWidgetAttemptParams>} LogObject<chatbotLoadWidgetAttemptParams>
 */
export function chatbotLoadWidgetAttempt(params) {
    return { evid: 1113, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotLoadWidgetFailure' event (evid: 1114)
 *
 * Event description: The user fails to open the chatbot widget
 *
 * @param {chatbotLoadWidgetFailureParams} params - The parameters for this event
 * @property {string} node_name - Name of the chatbot node
 * @property {string} fail_details - to log dealer offer or any other valuable information for debug purpose
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - chatbot_view
 * @property {string} fail_reason - Reason why the chatbot couldn't load
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {number} notificationCount - Number of chat notifications the user had
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {GUID} visitor_id - visitor ID used for load widget events when uuid is unavailable
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} dealer_offer_id - only if loaded because of dealer offer
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} init_params - init params widget was called with
 * @return {LogObject<chatbotLoadWidgetFailureParams>} LogObject<chatbotLoadWidgetFailureParams>
 */
export function chatbotLoadWidgetFailure(params) {
    return { evid: 1114, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotLoadTooltip' event (evid: 1115)
 *
 * Event description: The user is shown a tooltip near the chatbot widget
 *
 * @param {chatbotLoadTooltipParams} params - The parameters for this event
 * @property {string} node_name - the name of the node
 * @property {string} tooltip_name - Title of the tooltip
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} node_type_id - the ID of the node type
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_type - the type of the node
 * @property {string} node_id - the ID of the node
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} tooltip_text - text shown to the user in the tooltip
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget is placed
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {boolean} is_onetime_tooltip - to indicate if the tooltip is the onetime notification in editor to let the user know the widget is available
 * @property {string} widget_state - open or closed
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotLoadTooltipParams>} LogObject<chatbotLoadTooltipParams>
 */
export function chatbotLoadTooltip(params) {
    return { evid: 1115, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotClickTooltip' event (evid: 1116)
 *
 * Event description: The chatbot widget is opened after the user clicks on a tooltip
 *
 * @param {chatbotClickTooltipParams} params - The parameters for this event
 * @property {string} tooltip_name - Title of the tooltip
 * @property {string} session_id - Widget session ID
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} tooltip_text - text shown to the user in the tooltip
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {boolean} is_onetime_tooltip - to indicate if the tooltip is the onetime notification in editor to let the user know the widget is available
 * @property {string} widget_state - open or closed
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} chatbot_state - describes the chatbot window state
 * @return {LogObject<chatbotClickTooltipParams>} LogObject<chatbotClickTooltipParams>
 */
export function chatbotClickTooltip(params) {
    return { evid: 1116, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotCloseTooltip' event (evid: 1117)
 *
 * Event description: The user closes a chatbot tooltip
 *
 * @param {chatbotCloseTooltipParams} params - The parameters for this event
 * @property {string} tooltip_name - Title of the tooltip
 * @property {string} session_id - Widget session ID
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} tooltip_text - text shown to the user in the tooltip
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {boolean} is_onetime_tooltip - to indicate if the tooltip is the onetime notification in editor to let the user know the widget is available
 * @property {string} widget_state - open or closed
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation_id of the chatbot
 * @property {GUID} msid - msid when relevant
 * @property {string} chatbot_state - describes the chatbot window state
 * @return {LogObject<chatbotCloseTooltipParams>} LogObject<chatbotCloseTooltipParams>
 */
export function chatbotCloseTooltip(params) {
    return { evid: 1117, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'widgetPresentedContent' event (evid: 1119)
 *
 * Event description: Fires when suggested solutions are presented to the user
 *
 * @param {widgetPresentedContentParams} params - The parameters for this event
 * @property {string} ticket_id - Presents ticket_id in case of of an active CC interaction
 * @property {string} lng - user's language
 * @property {string} session_id - Widget session ID
 * @property {boolean} is_chatbot_solution_click - to indicate if the user got to an article page in the widget after clicking a solution in the chatbot
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} priority_class - The priority class of the user
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} article_id - presented article _id for single article state
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} article_recommendation_version - version of DS article recommendation module
 * @property {string} category_id - indicates what's the category id the user is on in case of a category page
 * @property {string} widget_state - indicates the state and location of the widget in the window
 * @property {string} lang - Answers language
 * @property {string} last_user_intent_id - ID of the last intent the user got when moving from the Chatbot to the Widget
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - Name of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} solution_info - details about the widget content that's presented to the user/ interacted with by the user
 * @property {string} last_user_intent - Name of the last intent the user got when moving from the Chatbot to the Widget
 * @property {string} last_chatbot_node_id - ID of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} searched_text - text entered by the user in the search bar.
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<widgetPresentedContentParams>} LogObject<widgetPresentedContentParams>
 */
export function widgetPresentedContent(params) {
    return { evid: 1119, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'widgetContentInteraction' event (evid: 1120)
 *
 * Event description: Fires with a click on one of the content items or buttons in the help center widget
 *
 * @param {widgetContentInteractionParams} params - The parameters for this event
 * @property {string} ticket_id - Presents ticket_id in case of of an active CC interaction
 * @property {string} button_clicked - widget button/link/solution that was clicked
 * @property {string} lng - user's language
 * @property {string} last_user_intent_name - Name of the last intent the user got when moving from the Chatbot to the Widget
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb window state
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} priority_class - The priority class of the user
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} article_id - article_id
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} article_recommendation_version - version of DS article recommendation module
 * @property {string} category_id - indicates what's the category id the user is on in case of a category page
 * @property {string} widget_state - indicates the state and location of the widget in the window
 * @property {string} lang - Answers language
 * @property {string} clicked_value - In case of button_clicked = 'chatbot_notifications', this number indicates the number of notifications.
 * @property {string} last_user_intent_id - ID of the last intent the user got when moving from the Chatbot to the Widget
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - Name of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} solution_info - details about the widget content that's presented to the user/ interacted with by the user
 * @property {string} last_chatbot_node_id - ID of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} searched_text - text entered by the user in the search bar.
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<widgetContentInteractionParams>} LogObject<widgetContentInteractionParams>
 */
export function widgetContentInteraction(params) {
    return { evid: 1120, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'widgetPageEngagement' event (evid: 1121)
 *
 * Event description: Fires every 10 seconds to indicate the user is active on the page
 *
 * @param {widgetPageEngagementParams} params - The parameters for this event
 * @property {string} ticket_id - Presents ticket_id in case of of an active CC interaction
 * @property {string} lng - user's language
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {boolean} max_scroll_at_first_position - indicates if the entire article/page is visible to the user without having to scroll
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} priority_class - The priority class of the user
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} article_id - article id in a single article solution view the user interacts with
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {number} max_scroll - max % of the page the user reached while visiting the page
 * @property {boolean} activity_type_mouse_click - Type of activity the user performed (T if user clicked the mouse in the widget)
 * @property {boolean} activity_type_scroll - Type of activity the user performed (T if user scrolled)
 * @property {boolean} activity_type_widget_is_open - To indicate if the widget is open and in focus
 * @property {string} category_id - indicates what's the category id the user is on in case of a category page
 * @property {string} widget_state - indicates the state and location of the widget in the window
 * @property {boolean} activity_type_scroll_to_bottom - Type of activity the user performed (T if user scrolled all the way to the bottom of the widget page)
 * @property {string} lang - Answers language
 * @property {boolean} activity_type_scroll_added_content - Type of activity performed (T if content was added following a scroll down)
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {boolean} activity_type_mouse_move - activity_type_mouse_move
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} solution_info - details about the widget content that's presented to the user/ interacted with by the user
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<widgetPageEngagementParams>} LogObject<widgetPageEngagementParams>
 */
export function widgetPageEngagement(params) {
    return { evid: 1121, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'widgetHeaderButtonClick' event (evid: 1122)
 *
 * Event description: Fires when the user clicks one of these options in the widget header: resize, dock, minimize, undock.
 *
 * @param {widgetHeaderButtonClickParams} params - The parameters for this event
 * @property {string} ticket_id - Presents ticket_id in case of of an active CC interaction
 * @property {string} button_clicked - widget button/link/solution that was clicked
 * @property {string} lng - user's language
 * @property {number} context_page_numLevels - context_page_numLevels
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} old_position - location of the widget on the screen {x,y}
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} new_position - location of the widget on the screen {x,y}
 * @property {string} orig_page_name - orig_page_name
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} orig_platform - orig_platform
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} category_id - indicates what's the category id the user is on in case of a category page
 * @property {string} widget_state - indicates the state and location of the widget in the window
 * @property {string} lang - Answers language
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} solution_info - details about the widget content that's presented to the user/ interacted with by the user
 * @return {LogObject<widgetHeaderButtonClickParams>} LogObject<widgetHeaderButtonClickParams>
 */
export function widgetHeaderButtonClick(params) {
    return { evid: 1122, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotDisplayWarning' event (evid: 1123)
 *
 * Event description: A Warning message (note) should be displayed to the user if it takes to the chatbot to respond more than 5 seconds (Just a moment..) or 10 seconds (We're still working on it...) since user message.
 *
 * @param {chatbotDisplayWarningParams} params - The parameters for this event
 * @property {number} time_waited - the time user already waited and didn't get a response yet. could be 5 or 10
 * @property {string} node_name - name of the current chatbot node
 * @property {string} main_option_id - ID of the Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - URL where the chatbot is located (Contact page, articles)
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - widget, full screen, iframe, mobile
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - Number of threads opened
 * @property {string} previous_node_name - name of the previous chatbot node
 * @property {string} mapping_product - Product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} warning_type - the type of the warning for example 'ai model loading'
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} message_text - text of the message sent by the chatbot - could be  (Just a moment.., We're still working on it...)
 * @property {number} previous_node - DEPRECATED- DO NOT USE
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {GUID} message_id - ID of the message, if the two warnings happen together they will get the same message_id
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - Language the user sees in the chatbot (may be different from user's normal lng)
 * @property {string} conversation_id - ID of the conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotDisplayWarningParams>} LogObject<chatbotDisplayWarningParams>
 */
export function chatbotDisplayWarning(params) {
    return { evid: 1123, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotTooltipButtonClick' event (evid: 1125)
 *
 * Event description: Fires every time the user clicks on a button in the tooltip
 *
 * @param {chatbotTooltipButtonClickParams} params - The parameters for this event
 * @property {string} node_name - the name of the node
 * @property {string} tooltip_name - title of the tooltip
 * @property {string} lng - user's language
 * @property {string} button_type - the type of the button_id chosen by the user
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} node_type_id - the ID of the node type
 * @property {string} button_type_id - the button ID type of the chosen button_id
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} node_type - the node type
 * @property {string} node_id - the ID of the node
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} button_name - the text on the button
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} tooltip_text - text shown to the user in the tooltip
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} button_id - button_id
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} lang - chatbot language
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<chatbotTooltipButtonClickParams>} LogObject<chatbotTooltipButtonClickParams>
 */
export function chatbotTooltipButtonClick(params) {
    return { evid: 1125, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotStatusBannerStatusBannerShowed' event (evid: 1127)
 *
 * Event description: This event is triggered every time the banner is shown to users (meaning there is an incident / there was one in the past 10 minutes)
 *
 * @param {chatbotStatusBannerStatusBannerShowedParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} incident_state - Array of State of all incidents returned from the API (returned as same order of names); open/resolved
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} incident_name - Array of Names of all incidents returned from the API
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - Displayed language
 * @property {string} conversation_id - id of the conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} incident_severity - Array of Severity of all incidents returned from the API (returned as same order of names)
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<chatbotStatusBannerStatusBannerShowedParams>} LogObject<chatbotStatusBannerStatusBannerShowedParams>
 */
export function chatbotStatusBannerStatusBannerShowed(params) {
    return { evid: 1127, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotStatusBannerStatusBannerClicked' event (evid: 1128)
 *
 * Event description: This event is triggered every time the banner is clicked on by a user
 *
 * @param {chatbotStatusBannerStatusBannerClickedParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} incident_state - Array of State of all incidents returned from the API (returned as same order of names); open/resolved
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} incident_name - Array of Names of all incidents returned from the API
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - Displayed language
 * @property {string} conversation_id - id of the conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} incident_severity - Array of Severity of all incidents returned from the API (returned as same order of names)
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<chatbotStatusBannerStatusBannerClickedParams>} LogObject<chatbotStatusBannerStatusBannerClickedParams>
 */
export function chatbotStatusBannerStatusBannerClicked(params) {
    return { evid: 1128, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotStatusBannerStatusBannerDismissed' event (evid: 1129)
 *
 * Event description: This event is triggered every time the banner is dismissed by a user (clicked x)
 *
 * @param {chatbotStatusBannerStatusBannerDismissedParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} incident_state - Array of State of all incidents returned from the API (returned as same order of names); open/resolved
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} incident_name - Array of Names of all incidents returned from the API
 * @property {string} referral - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - Main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} user_intent - issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - Displayed language
 * @property {string} conversation_id - id of the conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} incident_severity - Array of Severity of all incidents returned from the API (returned as same order of names)
 * @property {string} parent_url - parent_url
 * @return {LogObject<chatbotStatusBannerStatusBannerDismissedParams>} LogObject<chatbotStatusBannerStatusBannerDismissedParams>
 */
export function chatbotStatusBannerStatusBannerDismissed(params) {
    return { evid: 1129, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'schedulerUserSearchedADifferentMonth' event (evid: 1151)
 *
 * Event description: New Scheduler This event should fire every time the user clicks on one of the left/right arrows that enable searching for different months
 *
 * @param {schedulerUserSearchedADifferentMonthParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} referral - Where the user is coming from. the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} user_intent - Name of the last intent the user got when moving from the Chatbot to the scheduler. issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - User's Answers language
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<schedulerUserSearchedADifferentMonthParams>} LogObject<schedulerUserSearchedADifferentMonthParams>
 */
export function schedulerUserSearchedADifferentMonth(params) {
    return { evid: 1151, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'schedulerUserChoosesADay' event (evid: 1152)
 *
 * Event description: New Scheduler This event is triggered every time the user clicks on a day in the calendar
 *
 * @param {schedulerUserChoosesADayParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} info - array of new offered slots (day:hour)
 * @property {string} referral - Where the user is coming from. the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} user_intent - Name of the last intent the user got when moving from the Chatbot to the scheduler. issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - User's Answers language
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<schedulerUserChoosesADayParams>} LogObject<schedulerUserChoosesADayParams>
 */
export function schedulerUserChoosesADay(params) {
    return { evid: 1152, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'schedulerUserClickedOnASlot' event (evid: 1153)
 *
 * Event description: New Scheduler This event is triggered every time the user clicks on a slot
 *
 * @param {schedulerUserClickedOnASlotParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {string} chatbot_view - full page, widget, help widget etc.
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} mapping_product - Product mapping for DS team
 * @property {string} info - picked slot (day:hour)
 * @property {string} referral - Where the user is coming from. the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} user_intent - Name of the last intent the user got when moving from the Chatbot to the scheduler. issue the user is trying to solve (e.g. connect domain, transfer a domain)
 * @property {string} lang - User's Answers language
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<schedulerUserClickedOnASlotParams>} LogObject<schedulerUserClickedOnASlotParams>
 */
export function schedulerUserClickedOnASlot(params) {
    return { evid: 1153, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotClickOnSolution' event (evid: 1159)
 *
 * Event description: Fires every time a user clicks on a solution (e.g. article) in order to view the full solution
 *
 * @param {chatbotClickOnSolutionParams} params - The parameters for this event
 * @property {string} lng - user's language
 * @property {number} context_page_numLevels - context_page_numLevels
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} mapping_url - URL mapping for DS team
 * @property {string} context_parenturl - context_parenturl
 * @property {string} current_page_name - page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} intent_id - id of the user_intent
 * @property {string} mapping_product - product mapping for DS team
 * @property {GUID} bot_id - ID of the chatbot
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} solution_id - the ID of the solution
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - where the user is coming from
 * @property {string} orig_platform - location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - main Category from the contact page (Domains, Mailboxes, etc)
 * @property {string} solution_type - the type of the solution {e.g. Article...}
 * @property {string} lang - chatbot language
 * @property {string} conversation_id - id of the conversation
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} parent_url - the url where the user sees the widget
 * @return {LogObject<chatbotClickOnSolutionParams>} LogObject<chatbotClickOnSolutionParams>
 */
export function chatbotClickOnSolution(params) {
    return { evid: 1159, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'widgetEmptySearchResults' event (evid: 1160)
 *
 * Event description: Fires when an empty search result is presented to the user
 *
 * @param {widgetEmptySearchResultsParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {boolean} is_chatbot_solution_click - to indicate if the user got to an article page in the widget after clicking a solution in the chatbot
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} last_user_intent_id - ID of the last intent the user got when moving from the Chatbot to the Widget
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - Name of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} context_msid - context_msid
 * @property {string} last_user_intent - Name of the last intent the user got when moving from the Chatbot to the Widget
 * @property {string} last_chatbot_node_id - ID of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} searched_text - text entered by the user in the search bar.
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<widgetEmptySearchResultsParams>} LogObject<widgetEmptySearchResultsParams>
 */
export function widgetEmptySearchResults(params) {
    return { evid: 1160, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'breadcrumbsScroll' event (evid: 1161)
 *
 * Event description: Fires when the user scrolls the breadcrumbs left/right
 *
 * @param {breadcrumbsScrollParams} params - The parameters for this event
 * @property {string} scroll_direction - to indicate left/right scroll
 * @property {string} session_id - Widget session ID
 * @property {boolean} is_chatbot_solution_click - to indicate if the user got to an article page in the widget after clicking a solution in the chatbot
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context_parenturl - context_parenturl
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} percent_scrolled - max scroll position
 * @property {string} last_user_intent_id - ID of the last intent the user got when moving from the Chatbot to the Widget
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - Name of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} context_msid - context_msid
 * @property {string} last_user_intent - Name of the last intent the user got when moving from the Chatbot to the Widget
 * @property {string} last_chatbot_node_id - ID of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<breadcrumbsScrollParams>} LogObject<breadcrumbsScrollParams>
 */
export function breadcrumbsScroll(params) {
    return { evid: 1161, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'chatbotNotifications' event (evid: 1162)
 *
 * Event description: Fires when a new notification is fired from the Chabot while the chatbot is minimized
 *
 * @param {chatbotNotificationsParams} params - The parameters for this event
 * @property {string} session_id - Widget session ID
 * @property {boolean} is_chatbot_solution_click - to indicate if the user got to an article page in the widget after clicking a solution in the chatbot
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context_parenturl - context_parenturl
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} placement - Where the widget triggered from
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} last_user_intent_id - ID of the last intent the user got when moving from the Chatbot to the Widget
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - Name of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} context_msid - context_msid
 * @property {string} last_user_intent - Name of the last intent the user got when moving from the Chatbot to the Widget
 * @property {string} last_chatbot_node_id - ID of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {number} counter_value - number of unread notifications
 * @return {LogObject<chatbotNotificationsParams>} LogObject<chatbotNotificationsParams>
 */
export function chatbotNotifications(params) {
    return { evid: 1162, src: 4, endpoint: 'chatbot', params: params };
}
/**
 * A function to create a log object for the 'widgetHeaderClick' event (evid: 1164)
 *
 * Event description: Fires when a user clicks an icon in the widget header
 *
 * @param {widgetHeaderClickParams} params - The parameters for this event
 * @property {string} button_clicked - button clicked
 * @property {string} session_id - Widget session ID
 * @property {boolean} is_chatbot_solution_click - to indicate if the user got to an article page in the widget after clicking a solution in the chatbot
 * @property {string} context_platform - context_platform
 * @property {string} previous_presented_state - Indicate what was the previous content state the user was viewing
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context_parenturl - context_parenturl
 * @property {string} current_presented_state - Indicate what's the current content state the user is viewing
 * @property {string} current_page_name - Page of current chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} referral_info - Where the user is coming from
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} orig_page_name - Page of start chat {in Biz manager for example - Settings, Dashboard, Blog ...}
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} last_conversation_id - ID of the last conversation the user got when moving from the Chatbot to the Widget
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} referral - Where the user is coming from
 * @property {string} orig_platform - Location of chat start
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} clicked_value - value clicked
 * @property {string} last_user_intent_id - last_user_intent_id
 * @property {GUID} msid - msid when relevant
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} last_chatbot_node_name - Name of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {string} context_msid - context_msid
 * @property {string} last_user_intent - Name of the last intent the user got when moving from the Chatbot to the Widget
 * @property {string} last_chatbot_node_id - ID of the last chatbot node the user got when moving from the Chatbot to the Widget
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<widgetHeaderClickParams>} LogObject<widgetHeaderClickParams>
 */
export function widgetHeaderClick(params) {
    return { evid: 1164, src: 4, endpoint: 'chatbot', params: params };
}
//# sourceMappingURL=index.js.map